import {Injectable} from '@angular/core';
import {DeliveryClient, IDeliveryClient, TypeResolver} from '@kentico/kontent-delivery';
import {environment} from 'src/environments/environment';
import {Article} from './models/article';
import {Button} from './models/button';
import {Category} from './models/category';
import {CategoryLink} from './models/category_link';
import {ContentSectionBrightcoveVideo} from './models/content_section___brightcove_video';
import {ContentSectionCategoryLinks} from './models/content_section___category_links';
import {ContentSectionFullWidthImage} from './models/content_section___full_width_image';
import {ContentSectionPersonProfiles} from './models/content_section___person_profiles';
import {ContentSectionText} from './models/content_section___text';
import {Course} from './models/course';
import {Lesson} from './models/lesson';
import {Page} from './models/page';
import {PageAbout} from './models/page___about';
import {SourceContentExternalUrl} from './models/source_content___external_url';
import {SourceContentPdf} from './models/source_content___pdf';
import {SourceContentPodcast} from './models/source_content___podcast';
import {SourceContentVideo} from './models/source_content___video';
import {Tag} from './models/tag';

@Injectable({
	providedIn: 'root'
})
export class KontentService {
	public deliveryClient: IDeliveryClient;

	constructor() {
		this.deliveryClient = new DeliveryClient({
			projectId: environment.kontent.deliveryProjectId,
			previewApiKey: environment.kontent.previewApiKey,
			globalQueryConfig: {
				usePreviewMode: environment.kontent.usePreviewMode
			},
			typeResolvers: [
				new TypeResolver('article', () => new Article()),
				new TypeResolver('button', () => new Button()),
				new TypeResolver('category', () => new Category()),
				new TypeResolver('category_link', () => new CategoryLink()),
				new TypeResolver('content_section__brightcove_video', () => new ContentSectionBrightcoveVideo()),
				new TypeResolver('content_section__category_links', () => new ContentSectionCategoryLinks()),
				new TypeResolver('content_section__full_width_image', () => new ContentSectionFullWidthImage()),
				new TypeResolver('content_section__person_profiles', () => new ContentSectionPersonProfiles()),
				new TypeResolver('content_section__text', () => new ContentSectionText()),
				new TypeResolver('course', () => new Course()),
				new TypeResolver('lesson', () => new Lesson()),
				new TypeResolver('page', () => new Page()),
				new TypeResolver('page___about', () => new PageAbout()),
				new TypeResolver('source_content___external_url', () => new SourceContentExternalUrl()),
				new TypeResolver('source_content___pdf', () => new SourceContentPdf()),
				new TypeResolver('source_content___podcast', () => new SourceContentPodcast()),
				new TypeResolver('source_content___video', () => new SourceContentVideo()),
				new TypeResolver('tag', () => new Tag()),
			]
		});
	}
}
